import { Check } from 'lucide-react';

interface Step {
  label: string;
  status: 'completed' | 'active' | 'pending';
}

interface ProgressStepperProps {
  steps: Step[];
}

export function ProgressStepper({ steps }: ProgressStepperProps) {
  return (
    <div className="flex flex-col gap-0">
      {steps.map((step, i) => (
        <div key={i} className="flex items-start gap-3">
          {/* Dot / check */}
          <div className="flex flex-col items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all ${
                step.status === 'completed'
                  ? 'bg-[#523EF7] text-white'
                  : step.status === 'active'
                    ? 'bg-[#523EF7]/15 text-[#523EF7] animate-pulse-dot'
                    : 'bg-[#E8E8E8] text-[#9A9A9A]'
              }`}
            >
              {step.status === 'completed' ? <Check size={16} /> : i + 1}
            </div>
            {i < steps.length - 1 && (
              <div
                className={`w-0.5 h-6 ${
                  step.status === 'completed' ? 'bg-[#523EF7]' : 'bg-[#DDDDDD]'
                }`}
              />
            )}
          </div>
          {/* Label */}
          <div className="pt-1.5">
            <p
              className={`text-sm font-medium ${
                step.status === 'completed'
                  ? 'text-[#222222]'
                  : step.status === 'active'
                    ? 'text-[#523EF7]'
                    : 'text-[#9A9A9A]'
              }`}
            >
              {step.label}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}
